import { Currency, Money } from '@rygen/rygen-ui/model';

import { CargoInsuranceCommodityExclusionDetail } from './CargoInsuranceCommodityExclusionDetail';
import { CargoInsuranceStatus } from './CargoInsuranceStatus';

export class CargoInsuranceQuote {
  corsairShipmentCargoInsuranceId: number;
  shipmentId: number;
  status: CargoInsuranceStatus;
  productId: string;
  productName: string;
  productDescription: string;
  limit: Money;
  deductible: Money;
  premium?: Money;
  serviceFee?: Money;
  tax?: Money;
  uplift?: Money;
  totalCost: Money;
  commodityExclusions: CargoInsuranceCommodityExclusionDetail[];
  termsAndConditionsLink: string;
  statementOfFact: string;

  constructor(opts?: Partial<CargoInsuranceQuote>) {
    const fallbackCurrency = opts?.premium?.currency ?? Currency.USD;

    if (opts?.limit) {
      this.limit = new Money(opts.limit);
    } else {
      this.limit = Money.zero(fallbackCurrency);
    }

    if (opts?.deductible) {
      this.deductible = new Money(opts.deductible);
    } else {
      this.deductible = Money.zero(fallbackCurrency);
    }

    if (opts?.premium) {
      this.premium = new Money(opts.premium);
    }

    if (opts?.serviceFee) {
      this.serviceFee = new Money(opts.serviceFee);
    }

    if (opts?.tax) {
      this.tax = new Money(opts.tax);
    }

    if (opts?.uplift) {
      this.uplift = new Money(opts.uplift);
    }

    if (opts?.totalCost) {
      this.totalCost = new Money(opts.totalCost);
    } else {
      this.totalCost = Money.zero(fallbackCurrency);
    }

    this.corsairShipmentCargoInsuranceId =
      opts?.corsairShipmentCargoInsuranceId || -1;
    this.shipmentId = opts?.shipmentId || -1;
    this.status = opts?.status ?? 'CERTIFICATE_ISSUED';

    this.productId = opts?.productId ?? '';
    this.productName = opts?.productName ?? '';
    this.productDescription = opts?.productDescription ?? '';
    this.commodityExclusions =
      opts?.commodityExclusions?.map(
        (x) => new CargoInsuranceCommodityExclusionDetail(x),
      ) ?? [];
    this.termsAndConditionsLink = opts?.termsAndConditionsLink ?? '';
    this.statementOfFact = opts?.statementOfFact ?? '';
  }
}
